// checks if an item fits in the row above without overlapping
const fits = (item, row) => {
  for (var i = 0; i < row.length; i++) {
    if (row[i].absStartHour < Math.max(item.absStartHour + 1, item.absEndHour + 0.25) && Math.max(row[i].absStartHour + 1, row[i].absEndHour + 0.25) > item.absStartHour) return false;
  }
  return true;
}

const formatSchedule = (schedule) => {
  let locations = schedule.reduce(function(acc, cat) {
    for (const item of cat.items) {
      const generalLocation = item.location.split(' ')[0];
      if (!(generalLocation in acc)) acc[generalLocation] = {cat: {}};
      if (!(cat.name in acc[generalLocation].cat)) acc[generalLocation].cat[cat.name] = [];
      acc[generalLocation].cat[cat.name].push(item);
    }
    return acc;
  }, {});
  for (const key in locations) {
    locations[key].rows = Object.keys(locations[key].cat).reduce((acc, catKey) => { 
      var oldAccLength = acc.length; // make a shallow copy

      const cat = locations[key].cat[catKey];
      
      for (var i = 0; i < cat.length; i++) {
        var item = cat[i];
        let curRow = oldAccLength;
        do {
          curRow--;
        } while (curRow >= 0 && fits(item, acc[curRow]));
        do {
          curRow++;
        } while (curRow < acc.length && !fits(item, acc[curRow]));
        item.row = curRow;
        while (curRow >= acc.length) {
          acc.push([]);
        }
        acc[curRow].push(item);
      }
      return acc;
    }, []);
  }
  // transform to array
  locations = Object.keys(locations).map(key => ({
    key,
    ...locations[key]
  }));
  const items = schedule.reduce(function(acc, cat) {
    return cat.items.reduce(function(acc2, item){
      acc2.push(item);
      return acc2;
    }, acc);
  }, []).sort((a, b) => {
    if (a.start < b.start) {
      return -1;
    } else if (a.start > b.start) {
      return 1;
    } else {
      return 0;
    }
  });
  return { locations, items };
};

export default formatSchedule;


// WEBPACK FOOTER //
// ./src/components/Schedule/ScheduleComponent/helpers/fetchSchedule/formatSchedule.js